import { css } from "styled-components";

export const InputResetStyle = css`
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font: inherit;
`;
